<app-header-container [includeBanner]="includeBanner" [isSystemBanner]="isSystemBanner">
  <div header-content>
    <app-back-button class="mb-1" *ngIf="showBackButton" (backClicked)="backButtonClicked.emit()" />
    <div class="d-flex justify-content-between align-items-center">
      <div class="text-container">
        <ng-container *ngIf="!isLoading; else titleShimmer">
          <div *ngIf="title !== ''" class="header-text">
            {{ title }}
          </div>
        </ng-container>
        <ng-template #titleShimmer>
          <lib-loading-shimmer [width]="'12rem'" [height]="'1.5rem'" />
        </ng-template>
        <div *ngIf="description !== ''" class="description-text">
          {{ description }}
        </div>
      </div>
      <div class="button-container">
        <button
          *ngIf="actionButtonLabel !== ''"
          class="primary-paddingless-text-button"
          (click)="actionButtonClicked.emit()">
          {{ actionButtonLabel }}
        </button>
      </div>
    </div>
    <div *ngIf="tabs.length > 0" class="header-row tab-bar">
      <app-tab-bar [tabs]="tabs" (selectedTab)="selectedTab.emit($event)" />
    </div>
  </div>
  <div *ngIf="includeBanner" banner-content>
    <ng-content></ng-content>
  </div>
</app-header-container>
